<div class="app-messaging-viewer bc-work-item-theme {{ messagingThemeClass }}">
  <ng-container *ngIf="workItem && visitor && !messagesLoading">
    <div class="messages-container" #scrollPane>
      <app-chat-messages [messages]="messages"
                         [isActive]="false"
                         [workItemId]="messagingId"
                         [workItemCreated]="workItem.Created"
                         [workItemType]="messagingType"></app-chat-messages>
    </div>

    <app-text-chat-actions *ngIf="isTextChatActive()"
                           [messages]="messages"
                           [isInProgress]="isInProgress()"
                           [isAnswerable]="false"
                           [visitorName]="workItem.ChatName"></app-text-chat-actions>
  </ng-container>
  <app-loading *ngIf="!workItem || !visitor || messagesLoading"></app-loading>
</div>
